import { createContext } from 'react';
/**
 * Data Context for Chatbot
 * @public
 */
export var ChatbotDataContext = createContext({});